import EntityTable from "@mirage/components/entityTable/EntityTable";
import { useDeviceDetect } from "@mirage/hooks/useDeviceDetect";
import { TablePaginationBaseProps } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { TrackedApplicationService } from "@publicPortal/services/TrackedApplicationService";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { memo, useCallback, useMemo } from "react";

const trackedApplicationService = new TrackedApplicationService();

const NotificationsTab = memo(() => {
    const { isMobile } = useDeviceDetect();
    const onPageRequest = useCallback(async (pageRequest: IEntityPageRequest) => await trackedApplicationService.pageNotificationsRequest(pageRequest), []);
    const dateColumnDimensions = useMemo(() => (isMobile ? { width: 150, flex: undefined } : undefined), [isMobile]);
    const nameColumnDimensions = useMemo(() => (isMobile ? { width: 150, flex: undefined } : undefined), [isMobile]);
    const changesColumnDimensions = useMemo(() => (isMobile ? { width: 300, flex: undefined } : undefined), [isMobile]);
    const columns: GridColDef[] = useMemo(() => {
        return [
            { field: "lastModifiedTime", headerName: "Date", type: "dateTime", flex: 0.25, ...dateColumnDimensions },
            { field: "name", headerName: "Name", flex: 0.25, ...nameColumnDimensions },
            { field: "changes", headerName: "Changes", sortable: false, flex: 1, ...changesColumnDimensions },
        ];
    }, [changesColumnDimensions, dateColumnDimensions, nameColumnDimensions]);
    const overridePaginationProps = useCallback((baseProps: TablePaginationBaseProps) => ({ ...baseProps, showFirstButton: false, showLastButton: false }), []);

    return (
        <EntityTable
            title="Notifications"
            key="notifications-tab-entityTable"
            stateKey="notificationsTab"
            onPageRequest={onPageRequest}
            columns={columns}
            hideRowsPerPage={isMobile}
            overridePaginationProps={overridePaginationProps}
        />
    );
});

export default NotificationsTab;
